<template>
  <div class="mt-2">
    <b-form>
      <b-row>
        <b-col cols="12" md="6">
          <!-- DO (Door Open) Section -->
          <b-form-group label="DO Message" label-for="doMessage" label-cols="5">
            <b-form-select id="doMessage" v-model="zoneForm.doMessage" :options="messageOptions"
              :disabled="!actionFields.doMessage" />
          </b-form-group>

          <b-form-group label="DO Output" label-for="doOutputFireBell" label-cols="5">
            <validation-provider #default="{ errors }" name="DO Output"
              rules="numeric|min_value:0|max_value:999">
              <b-form-input id="doOutputFireBell" v-model="zoneForm.doOutputFireBell" type="text"
                :state="errors.length > 0 ? false : null" maxlength="3" placeholder="000"
                :disabled="!actionFields.doOutputFireBell" @input="handleOutputInput(zoneForm.doOutputFireBell, 'doOutputAction')"/>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>

          <b-form-group label="DO Output Action" label-for="doOutputAction" label-cols="5">
            <b-form-select id="doOutputAction" v-model="zoneForm.doOutputAction" :options="outputActionOptions"
              :disabled="!actionFields.doOutputAction" />
          </b-form-group>

          <!-- DS (Door/Secure) Section -->
          <b-form-group label="DS Message" label-for="dsMessage" label-cols="5">
            <b-form-select id="dsMessage" v-model="zoneForm.dsMessage" :options="messageOptions"
              :disabled="!actionFields.dsMessage" />
          </b-form-group>

          <b-form-group label="DS Output" label-for="dsOutput" label-cols="5">
            <validation-provider #default="{ errors }" name="DS Output" rules="numeric|min_value:0|max_value:999">
              <b-form-input id="dsOutput" v-model="zoneForm.dsOutput" type="text"
                :state="errors.length > 0 ? false : null" maxlength="3" placeholder="000"
                :disabled="!actionFields.dsOutput" @input="handleOutputInput(zoneForm.dsOutput, 'dsOutputAction')"/>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>

          <b-form-group label="DS Output Action" label-for="dsOutputAction" label-cols="5">
            <b-form-select id="dsOutputAction" v-model="zoneForm.dsOutputAction" :options="outputActionOptions"
              :disabled="!actionFields.dsOutputAction" />
          </b-form-group>

          <!-- AO (Alarm Open) Section -->
          <b-form-group label="AO Message" label-for="aoMessage" label-cols="5">
            <b-form-select id="aoMessage" v-model="zoneForm.aoMessage" :options="messageOptions"
              :disabled="!actionFields.aoMessage" />
          </b-form-group>

          <b-form-group label="AO Output" label-for="aoOutput" label-cols="5">
            <validation-provider #default="{ errors }" name="AO Output" rules="numeric|min_value:0|max_value:999">
              <b-form-input id="aoOutput" v-model="zoneForm.aoOutput" type="text"
                :state="errors.length > 0 ? false : null" maxlength="3" placeholder="000"
                :disabled="!actionFields.aoOutput" @input="handleOutputInput(zoneForm.aoOutput, 'aoOutputAction')"/>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>

          <b-form-group label="AO Output Action" label-for="aoOutputAction" label-cols="5">
            <b-form-select id="aoOutputAction" v-model="zoneForm.aoOutputAction" :options="outputActionOptions"
              :disabled="!actionFields.aoOutputAction" />
          </b-form-group>

          <!-- AS (Alarm/Secure) Section -->
          <b-form-group label="AS Message" label-for="asMessage" label-cols="5">
            <b-form-select id="asMessage" v-model="zoneForm.asMessage" :options="messageOptions"
              :disabled="!actionFields.asMessage" />
          </b-form-group>

          <b-form-group label="AS Output" label-for="asOutput" label-cols="5">
            <validation-provider #default="{ errors }" name="AS Output" rules="numeric|min_value:0|max_value:999">
              <b-form-input id="asOutput" v-model="zoneForm.asOutput" type="text"
                :state="errors.length > 0 ? false : null" maxlength="3" placeholder="000"
                :disabled="!actionFields.asOutput" @input="handleOutputInput(zoneForm.asOutput, 'asOutputAction')"/>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-form-group>

          <b-form-group label="AS Output Action" label-for="asOutputAction" label-cols="5">
            <b-form-select id="asOutputAction" v-model="zoneForm.asOutputAction" :options="outputActionOptions"
              :disabled="!actionFields.asOutputAction" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { computed, toRefs, watch } from "@vue/composition-api";
import { ValidationProvider } from "vee-validate";
import { MESSAGE_TYPE_OPTIONS, OUTPUT_ACTION_OPTIONS } from "./useZoneConfig";
import { useZoneFieldsEnabled } from "./useZoneFieldsEnabled";

export default {
  name: "ZoneAction",
  components: {
    ValidationProvider,
  },
  props: {
    zoneForm: {
      type: Object,
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const messageOptions = MESSAGE_TYPE_OPTIONS;
    const outputActionOptions = OUTPUT_ACTION_OPTIONS;

    const { zoneForm } = toRefs(props);
    const zoneType = computed(() => zoneForm.value.zoneType);
    const { actionFields } = useZoneFieldsEnabled(zoneType);

    const outputActionMap = [
      { output: 'doOutputFireBell', action: 'doOutputAction' },
      { output: 'dsOutput',         action: 'dsOutputAction' },
      { output: 'aoOutput',         action: 'aoOutputAction' },
      { output: 'asOutput',         action: 'asOutputAction' },
    ];

    const handleOutputInput = (value, actionField) => {
      const num = parseInt(value, 10);
      if (!value || isNaN(num) || num === 0) {
        zoneForm.value[actionField] = 'NONE';
      }
    };

    return {
      messageOptions,
      outputActionOptions,
      actionFields,
      handleOutputInput,
    };
  },
};
</script>
